import { render, staticRenderFns } from "./rejected-claim.vue?vue&type=template&id=1d05ec54"
import script from "./rejected-claim.vue?vue&type=script&lang=js"
export * from "./rejected-claim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports